import * as yup from "yup";

export const addAndChangeSchema = (translate: Function) => yup.object().shape({
	mda001Titulo: yup.string().required(translate("Título é requerido")),
	mda001Descricao: yup.string().required(translate("Descrição é requerido")),
	mda001Ativo: yup.boolean()
});


export const addAndChangeSchemaCriteria = (translate: Function) => yup.object().shape({
	mda002Titulo: yup.string().required(translate("Título é requerido")),
	mda002Descricao: yup.string(),
	mda002Conceito: yup.string()
});


export const addAndChangeSchemaQuestion = (translate: Function) => yup.object().shape({
	mda003Questao: yup.string().required(translate("Questão é requerida")),
	mda003Descricao: yup.string().required(translate("Descrição é requerido")),
	mda003Pontuacao: yup.string().required(translate("Pontuação é requerida"))
});

export const addAndChangeSchemaAnswer = (translate: Function) => yup.object().shape({
	mda004Resposta: yup.string().required(translate("Resposta é requerida")),
	mda004Descricao: yup.string()
});

export const deleteSchema = (translate: Function) => yup.object().shape({
	mda001Titulo: yup.string().required(translate("Titulo do modelo de diagnóstico não confere")).oneOf([yup.ref("mda001TituloConfirmation")], translate("Titulo do modelo de diagnóstico não confere"))
});


